import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAppSelector } from '../../app/hooks';

// Page titles map
const pageTitles = {
    '/': 'Dashboard',
    '/categories': 'Categories',
    '/stories': 'Stories',
    '/tags': 'Tags',
    '/novel-categories': 'Novel Categories',
    '/novels': 'Novels',
};

export function MainLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const { mode } = useAppSelector((state) => state.theme);

    // Apply theme class to document
    useEffect(() => {
        if (mode === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [mode]);

    const currentTitle = pageTitles[location.pathname] || 'Admin Panel';

    return (
        <div className="h-screen bg-slate-50 dark:bg-slate-900 flex overflow-hidden">
            {/* Sidebar */}
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            {/* Main content */}
            <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
                <Header
                    onMenuClick={() => setSidebarOpen(true)}
                    title={currentTitle}
                />

                <main className="flex-1 p-4 lg:p-6 overflow-y-auto">
                    <div className="max-w-7xl mx-auto">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}

export default MainLayout;
